import React, { Fragment } from 'react';

// import { ErrorAlert } from '../components/ErrorAlert';

export const Page404 = () => {
	return (
		<Fragment>
			{/* <ErrorAlert errorMessage='404' /> */}
			<div class="abs-center wd-xl">
				<div class="text-center mb-4">
					<div class="text-lg mb-3">404</div>
					<p class="lead m-0">We couldn't find this page.</p>
					<p>The page you are looking for does not exists.</p>
				</div>
				{/* <div class="input-group mb-4"><input class="form-control" type="text" placeholder="Try with a search"/><span class="input-group-btn"><button class="btn btn-secondary" type="button"><em class="fa fa-search"></em></button></span></div> */}
				<ul class="list-inline text-center text-sm mb-4">
					<li class="list-inline-item"><a class="text-muted" href="/">Back to Home</a></li>
				</ul>
				<div class="p-3 text-center"><span class="mr-2">&copy;</span><span>2022</span><span class="mr-2">-</span><span>ALEX</span><br/></div>
			</div>
		</Fragment>
	);
};